import m from "./index455.js";
import { createElementBlock as t, openBlock as a, createElementVNode as i, Fragment as p, renderList as u, normalizeClass as l, toDisplayString as d } from "vue";
/* empty css         */
import f from "./index231.js";
const v = ["data-component"], g = {
  ref: "wrapper",
  class: "ms-navBar__items"
}, _ = ["target", "rel", "href", "onClick"], c = { class: "ms-navBar__itemLinkText" };
function h(e, n, k, B, M, L) {
  return a(), t("nav", {
    class: "ms-navBar",
    "data-component": e.$options.name
  }, [
    i("ul", g, [
      (a(!0), t(p, null, u(e.navigationItems, (o, r) => (a(), t("li", {
        key: r,
        ref_for: !0,
        ref: "items",
        class: l(["ms-navBar__item", { "-hidden": !e.isVisible(r) }]),
        onMouseenter: n[0] || (n[0] = (...s) => e.onMouseEnter && e.onMouseEnter(...s)),
        onMouseleave: n[1] || (n[1] = (...s) => e.onMouseLeave && e.onMouseLeave(...s))
      }, [
        i("a", {
          class: l(["ms-navBar__itemLink", { "-active": o.highlighted && !e.state.suppressHighlight }]),
          target: o.target,
          rel: e.getRel(o.nofollow),
          href: o.url,
          onClick: (s) => e.linkTracking(r, e.navLevel2, o.text, s)
        }, [
          i("span", c, d(o.text), 1)
        ], 10, _)
      ], 34))), 128))
    ], 512)
  ], 8, v);
}
const w = /* @__PURE__ */ f(m, [["render", h], ["__scopeId", "data-v-d1b54ae8"]]);
export {
  w as default
};
